import React from "react";
import { useSelector } from "react-redux";
import Marquee from "react-fast-marquee";
import { AiFillSound } from "react-icons/ai";
import {
  Box,
  Flex,
  Icon,
  Image,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import useMarqueeList from "../../hook/useMarqueeList";
import { COMMON_WEB_PATH } from "../../constant";
import useCheckLogin from "../../hook/useCheckLogin";

const MarqueeList = () => {
  const marqueeList = useMarqueeList();

  const { isLogin, isMachineUser, isMachineDomain } = useCheckLogin();

  const bg = useColorModeValue("light.200", "#262D47");
  const color = useColorModeValue("dark.100", "text.100");

  return (
    <Flex
      //bg={bg}
      bgSize="100% 100%"
      bgPosition="center"
      bgRepeat="no-repeat"
      color="#fff"
      //borderRadius={`full`}
      borderRadius={{ base: "full" }}
      border={{
        base: "2px solid #9A8CA4",
      }}
      bgColor={{
        base: "#130F13",
      }}
      alignItems={`center`}
      gap={`10px`}
      px="5px"
      pl="25px"
      py="5px"
      // w="100%"
      w={{ base: "100%", md: "100%" }}
      overflow="hidden"
      minH="39px"
      maxH="50px"
    >
      {/* <Icon as={AiFillSound} color="#fff" /> */}
      <Image
        src={`${COMMON_WEB_PATH}/theOne/marquee_icon.png`}
        w={{
          base: "20px",
          md: "25px",
        }}
        display={{ base: "block", md: "block" }}
      />
      <Marquee className="">
        {marqueeList?.map((item, index) => {
          const { subject, content } = item;
          return (
            <Flex mr="40px" key={`marquee-${index}`}>
              <Text
                color="#BFAFCD"
                fontWeight={"medium"}
                fontSize={{
                  base: "md",
                  md: "lg",
                }}
              >
                {content}
              </Text>
            </Flex>
          );
        })}
      </Marquee>
    </Flex>
  );
};

export default MarqueeList;
